import { render, staticRenderFns } from "./babyInfo.vue?vue&type=template&id=4a615b0e&scoped=true"
import script from "./babyInfo.vue?vue&type=script&lang=js"
export * from "./babyInfo.vue?vue&type=script&lang=js"
import style0 from "./babyInfo.vue?vue&type=style&index=0&id=4a615b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a615b0e",
  null
  
)

export default component.exports